<template>
  <div class="my-2">
    <div v-if="vesselSubTypeInfo && sectionIndex == null && !currentSection">
      <h4>Ship Image:</h4>
      <div class="image-container w-full pl-0 pr-0 mb-3">
        <img
          ref="shipImg"
          :src="vesselSubTypeInfo.ship_image_url"
          width="1000px"
          height="600px"
          style="min-width: 1000px; max-height: 600px; object-fit: contain"
          alt="vessel-type-image"
          class="cursor-auto"
        />
        <div
          class="legend"
          :style="{ top: top + 'px', right: right + 'px' }"
          v-if="sections.length > 0"
        >
          <div
            class="d-flex legend-header justify-content-between align-items-center legend-title mover"
            @mousedown="startDrag"
          >
            <h4 class="fs-medium mb-0">Legend</h4>
            <span
              class="fs-small text-info cursor-pointer"
              @click="isShowSectionLegend = !isShowSectionLegend"
              >{{ isShowSectionLegend ? "Hide" : "Show" }}</span
            >
          </div>
          <div class="resizer" v-if="isShowSectionLegend">
            <div v-if="isShowSectionLegend" class="h-100 overflow-auto">
              <hr class="my-1" />
              <div
                v-for="(section, index) in sections"
                :key="`legend_${index}`"
                class="legend-item"
                :class="{ 'text-warning': !section.location }"
                @click="openSubFolder(section, index)"
              >
                {{ indexFindSection(section) + 1 }} - {{ section.folder_name }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="(section, sectionIndex) in mappedSections"
          :key="`section_pin_${sectionIndex}`"
          class="pin cursor-pointer"
          :style="{
            left: section.location.x + 'px',
            top: section.location.y + 'px',
          }"
          @click="openSubFolderView(section)"
        >
          <div
            class="text-white"
            :class="section.location.color == 'red' ? 'red-pin' : 'yellow-pin'"
            draggable="true"
          >
            {{ indexFindSection(section) + 1 }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentSection && sectionIndex > -1 && !folderView">
      <div class="header mb-6">
        <vs-button
          color="dark"
          type="flat"
          icon-pack="feather"
          icon="icon-arrow-left"
          class="p-0"
          @click="goToSectionView()"
        ></vs-button>
        <div class="w-full justify-right">
          <h2 class="pl-2">Sub Folders</h2>
        </div>
      </div>
      <div>
        <div v-if="currentSection.ga_plan_image">
          <h4>{{ currentSection.folder_name }} - GA Plan Image:</h4>
          <div class="image-container w-full pl-0 pr-0 mb-3">
            <div class="relative">
              <img
                ref="ga_plan_image"
                :src="currentSection.ga_plan_image"
                style="width: 1000px; height: 600px; object-fit: contain"
                height="500px"
                alt="ga-plan-image"
                class="cursor-auto"
                title="Fullscreen"
                @click="showImageModal(currentSection.ga_plan_image)"
              />
              <div class="absolute m-2 top-0">
                <vs-button
                  color="dark"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-maximize"
                  class="p-0"
                  title="Fullscreen"
                  @click="showImageModal(currentSection.ga_plan_image)"
                ></vs-button>
              </div>
            </div>

            <div
              class="legend"
              :style="{ top: top + 'px', right: right + 'px' }"
              v-if="activeFolders(currentSection.subFolders).length > 0"
            >
              <div
                class="d-flex legend-header justify-content-between align-items-center legend-title mover"
                @mousedown="startDrag"
              >
                <h4 class="fs-medium mb-0">Legend</h4>
                <span
                  class="fs-small text-info cursor-pointer"
                  @click="isShowFolderLegend = !isShowFolderLegend"
                  >{{ isShowFolderLegend ? "Hide" : "Show" }}</span
                >
              </div>
              <div class="resizer" v-if="isShowFolderLegend">
                <div v-if="isShowFolderLegend" class="h-100 overflow-auto">
                  <hr class="my-1" />
                  <div
                    v-for="(folder, index) in activeFolders(
                      currentSection.subFolders
                    )"
                    :key="`folder_legend_${index}`"
                    class="legend-item"
                    :class="{ 'text-warning': !folder.location }"
                    @click="openFolderView(folder, index)"
                  >
                    {{ indexFindFolder(folder) + 1 }} - {{ folder.folder_name }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="(folder, folderIndex) in mappedFolders"
              :key="`folder_pin_${folderIndex}`"
              class="pin cursor-pointer"
              :style="{
                left: folder.location.x + 'px',
                top: folder.location.y + 'px',
              }"
              @click="openFolderView(folder)"
            >
              <div
                class="text-white"
                :class="
                  folder.location.color == 'red' ? 'red-pin' : 'yellow-pin'
                "
              >
                {{ indexFindFolder(folder) + 1 }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="folder-container">
          <h4 class="text-primary mt-4">Sub Folders:</h4>

          <div class="scroll-container">
            <div
              class="scrollable-content"
              v-for="(folder, index) in activeFolders(
                currentSection.subFolders
              )"
              :key="`folder_${index}`"
            >
              <vs-card
                class="zoom-effect p-3 position-relative folder-card folder-card-bg"
                style="position: relative"
              >
                <div
                  class="cursor-pointer folder"
                  @click="openFolderView(folder, index)"
                >
                  <h4 class="mt-2 folder-name" :title="folder.folder_name">
                    {{ index + 1 }}.{{ folder.folder_name }}
                  </h4>
                </div>
              </vs-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="folderView">
      <div class="d-flex align-items-center">
        <vs-button
          color="primary"
          type="flat"
          icon="arrow_back"
          @click="folderView = null"
        ></vs-button>
        <h3 class="text-primary mb-0">{{ folderView.folder_name }}</h3>
      </div>
      <div>
        <div v-if="currentImage" class="relative w-full h-full">
          <div class="absolute m-3" style="top: 50%">
            <vs-button
              v-if="!(currentImage.index === 0)"
              radius
              class="opacity-75"
              color="primary"
              @click="changeImage(-1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="7"
                stroke="currentColor"
                class="w-6 h-6 text-white"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 19.5 8.25 12l7.5-7.5"
                />
              </svg>
            </vs-button>
          </div>
          <img
            v-if="currentImage"
            :src="currentImage.url"
            width="100%"
            style="max-height: 600px; object-fit: contain"
            class="mb-2"
            :id="`folder_image_${folderView.folder_name}`"
          />
          <div class="absolute m-2 top-0 right-0">
            <div class="d-flex">
              <vs-button
                color="dark"
                type="filled"
                icon-pack="feather"
                icon="icon-download"
                class="mr-1"
                title="Download"
                @click="downloadIMG(currentImage.url)"
              >
              </vs-button>
              <vs-button
                color="dark"
                type="filled"
                icon-pack="feather"
                icon="icon-maximize"
                title="Fullscreen"
                class="p-0"
                @click="showImageModal(currentImage.url)"
              >
              </vs-button>
            </div>
          </div>
          <div class="absolute m-3" style="top: 50%; right: 0px">
            <vs-button
              v-if="!(currentImage.index === folderView.files.length - 1)"
              radius
              class="opacity-75"
              color="primary"
              @click="changeImage(1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="7"
                stroke="currentColor"
                class="w-6 h-6 text-white"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
              </svg>
            </vs-button>
          </div>
        </div>
        <p
          v-if="folderView.files && folderView.files.length == 0"
          class="text-muted text-center h3 mt-4 pt-4"
        >
          No Images Available
        </p>
        <div class="scroll-container py-2">
          <div class="scrollable-content">
            <vs-card
              class="zoom-effect p-3 position-relative mb-1 text-center image-card position-relative"
              style="position: relative"
              v-for="(file, imageIndex) in folderView.files"
              :key="`file_${imageIndex}`"
              :class="{
                'border border-primary':
                  currentImage != null && currentImage.index == imageIndex,
              }"
            >
              <div class="h-100">
                <img
                  :src="file.thumbnail"
                  alt="ThumbnailImage"
                  class="image m-auto"
                  @click="showFullImage(file, imageIndex)"
                  :id="`${folderView.folder_name}_${imageIndex}`"
                />
              </div>
            </vs-card>
          </div>
        </div>
      </div>
    </div>
    <ImageModal
      :isVisible="imageModal.isShow"
      :imageUrl="imageModal.url"
      @close="closeImageModal"
    />
  </div>
</template>
<script>
import Vue from "vue";
import ImageModal from "@/layouts/image-modal.vue";
export default {
  components: {
    ImageModal,
  },
  props: {
    sectionInfo: {
      type: Array,
      default: [],
    },
    vesselSubTypeInfo: {
      type: Object,
      default: null,
    },
    project: {
      type: Object,
      default: null,
    },
    page: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sections: [],
      folderNamePopup: {
        title: "Add Folder",
        message: "Folder Name",
        action: null,
        isShow: false,
        data: null,
      },
      isDragging: false,
      draggingIndex: null,
      sectionIndex: null,
      isDraggingFolder: false,
      draggingFolderIndex: null,
      folderView: null,
      currentImage: null,
      selectedImages: [],
      isShowSectionLegend: true,
      isShowFolderLegend: true,
      dragging: false,
      top: 0,
      right: 0,
      startX: 0,
      startY: 0,
      sliderImageIndex: 0,
      imageModal: {
        isShow: false,
        url: null,
      },
    };
  },
  computed: {
    isAdmin() {
      return this.isUserType("A");
    },
    mappedSections() {
      return this.sections.filter((v) => v.location) || [];
    },
    currentSection() {
      return this.sectionIndex > -1 ? this.sections[this.sectionIndex] : null;
    },
    mappedFolders() {
      return this.currentSection
        ? this.currentSection.subFolders.filter(
            (v) => v.location && v.status != "N"
          )
        : [];
    },
    getFiles() {
      return this.folderView && this.folderView.files
        ? this.folderView.files
        : [];
    },
    getOriginalImageUrlWithIndex() {
      if (!this.folderView || !Array.isArray(this.folderView.files)) return [];

      return this.folderView.files
        .map((file, index) => {
          return {
            url: file.original || file.thumbnail,
            index,
          };
        })
        .filter((item) => item.url);
    },
  },
  mounted() {
    this.initSetup(this.sectionInfo);
  },
  watch: {
    sectionInfo(newVal) {
      this.initSetup(newVal);
    },
  },
  methods: {
    closeImageModal() {
      this.imageModal.isShow = false;
    },
    initSetup(data) {
      this.sections = data.map((v, index) => ({
        ...v,
        index,
        _id: `${Date.now()}${Math.floor(Math.random() * 1000)}`,
        subFolders: v.subFolders.map((s, sIndex) => ({
          ...s,
          index: sIndex,
          _id: `${Date.now()}${Math.floor(Math.random() * 1000)}`,
        })),
      }));
    },
    archiveFolder(info) {
      if (info != null) {
        const folder = info.folder;
        this.changeSubFolderStatus("N", folder);
      }
      this.folderNamePopup.isShow = false;
    },
    activeFolder(info) {
      if (info != null) {
        const folder = info.folder;
        this.changeSubFolderStatus("Y", folder);
      }
      this.folderNamePopup.isShow = false;
    },
    voidEvent() {
      return;
    },
    openSubFolder(section, index) {
      this.sectionIndex = index;
    },
    openSubFolderView(section) {
      if (["viewProject"].includes(this.page)) {
        const index = this.indexFindSection(section);
        this.sectionIndex = index;
      }
      return;
    },
    goToSectionView() {
      this.sectionIndex = null;
    },
    openFolderView(folder, index) {
      this.folderView = { ...folder, files: folder.files || [] };
      if (folder.id) {
        this.getSubFolderFiles(folder);
      }
    },
    async getSubFolderFiles(folder) {
      this.currentImage = null;
      this.sliderImageIndex = -1;
      const project_id = this.project ? this.project.id : null;
      const folder_id = folder.id;
      this.$vs.loading();
      const response = await this.getHTTPGetResponse(
        `projects/${project_id}/subfolder/${folder_id}/image`
      );
      this.$vs.loading.close();
      if (response && response.status == "200" && response.data) {
        const images = response.data.images;
        if (images.length) {
          this.currentImage = {
            url: images[0].original,
            index: 0,
          };
        } else {
          this.currentImage = null;
        }
        this.folderView = {
          ...this.folderView,
          files: response.data.images,
        };
      }
    },
    showOriginalImage(file, index) {
      this.sliderImageIndex = index;
      this.currentImage = {
        url: file.original || file.thumbnail,
        index: index,
      };
    },
    activeFolders(data) {
      return data.filter((v) => !(v.status === "N"));
    },
    archiveFolders(data) {
      return data.filter((v) => v.status === "N");
    },
    indexFindFolder(folder) {
      const _id = folder._id;
      const folders = this.sections[this.sectionIndex].subFolders;
      const index = this.activeFolders(folders).findIndex((v) => v._id === _id);
      return index > -1 ? index : "N/A";
    },
    indexFindSection(section) {
      const _id = section._id;
      const index = this.sections.findIndex((v) => v._id === _id);
      return index > -1 ? index : "N/A";
    },
    startDrag(e) {
      this.dragging = true;
      this.startX = e.clientX + this.right;
      this.startY = e.clientY - this.top;
      document.addEventListener("mousemove", this.move);
      document.addEventListener("mouseup", this.stopDrag);
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener("mousemove", this.move);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    move(e) {
      if (this.dragging) {
        this.top = e.clientY - this.startY;
        this.right = this.startX - e.clientX;
      }
    },
    generateRandomID() {
      return `${Date.now()}${Math.floor(Math.random() * 100)}`;
    },
    changeImage(step) {
      const newIndex = this.currentImage.index + step;
      const originalImages = this.getOriginalImageUrlWithIndex;

      if (newIndex >= 0 && newIndex < originalImages.length) {
        this.$vs.loading({
          type: "corners",
        });

        const newImage = originalImages[newIndex];
        const img = new Image();

        img.onload = () => {
          this.currentImage = newImage;
          this.$vs.loading.close();
        };

        img.onerror = () => {
          console.error("Failed to load image:", newImage.url);
          this.$vs.loading.close();
        };

        img.src = newImage.url;
      }
    },
    showFullImage(file, index) {
      const { original, thumbnail } = file;
      const imageUrl = original || thumbnail;

      this.$vs.loading({ type: "corners" });

      const img = new Image();
      img.onload = () => {
        this.sliderImageIndex = index;
        this.currentImage = {
          url: imageUrl,
          index: index,
        };
        this.$vs.loading.close();
      };
      img.onerror = () => {
        console.error("Failed to load image:", imageUrl);
        this.$vs.loading.close();
      };
      img.src = imageUrl;
    },
    showImageModal(url) {
      this.imageModal.isShow = !this.imageModal.isShow;
      if (this.imageModal.isShow) {
        this.imageModal.url = url || "";
      }
    },
  },
};
</script>
<style lang="css" scoped>
.scroll-container {
  overflow-x: auto;
  padding-bottom: 10px;
}
.scrollable-content {
  display: inline-block;
}
.folder-card {
  display: inline-block;
  width: 225px; /* Set your desired width */
  height: 150px;
  margin: 5px; /* Set margin between images */
}
.folder-card-bg {
  background-image: url('/foldericon.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.folder-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.image-container {
  position: relative;
}

.yellow-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: #ec9a29;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.red-pin::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 30px;
  height: 30px;
  background-color: red;
  border-radius: 50% 50% 50% 0;
  z-index: -1;
}

.marker {
  position: absolute;
  background-color: red;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.legend {
  position: absolute;
  background: #ffffff; /* Cleaner background for readability */
  border: 1px solid #d1d5db; /* Light gray border for subtle contrast */
  border-radius: 8px;
  min-width: 180px;
  max-width: 250px;
  max-height: 400px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08); /* Soft shadow for depth */
  overflow-y: auto;
  font-family: "Inter", "Arial", sans-serif; /* Modern font */
  color: #374151; /* Dark gray for text */
  transition: all 0.3s ease-in-out;
}

/* Header */
.legend-header {
  padding: 12px 14px;
  background: #f9fafb; /* Light header background */
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.legend-header h4 {
  margin: 0;
  font-size: 14px;
  color: #111827;
}

.legend-header span {
  font-size: 13px;
  color: #2563eb; /* Blue for interactive element */
  cursor: pointer;
  font-weight: 500;
}

.legend-header span:hover {
  text-decoration: underline;
}

/* Resizer & Scroll */
.resizer {
  padding: 10px 14px;
  background: #fff;
}

/* Items */
.legend-item {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  padding: 6px 0;
  border-bottom: 1px solid #f3f4f6;
  transition: background 0.2s;
}

.legend-item:last-child {
  border-bottom: none;
}

.legend-item:hover {
  background: #f9fafb; /* Hover effect for better UX */
  cursor: default;
}

/* Warning state */
.legend-item.text-warning {
  color: #f59e0b; /* Amber for warning */
}

.pin {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  transition: transform 0.3s ease, filter 0.3s ease;
}

.delete-image {
  position: absolute;
  top: 5px;
  right: 5px;
}

.custom-input-image {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

.scroll-container {
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 10px;
}

.fixed-card {
  display: inline-block;
  vertical-align: top;
}

.scrollable-content {
  display: inline-block;
}

.image-card {
  display: inline-block;
  width: 150px; /* Set your desired width */
  height: 150px;
  margin: 5px; /* Set margin between images */
  align-content: center;
}

.image {
  width: 100%;
  height: auto;
}
.folder-card .folder {
  padding: 10px;
  margin-bottom: 10px;
}
.fs-small {
  font-size: 12px;
}
.fs-medium {
  font-size: 14px;
}
.remove-btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7rem;
  top: 5px;
  right: 10px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  color: red;
}

.cursor-grab {
  cursor: grab;
}
.vs-button:disabled {
  cursor: not-allowed !important;
}
.legend-header {
  padding: 10px;
}
.mover {
  cursor: move !important;
}
.resizer {
  margin: 5px;
  overflow: hidden;
  resize: both;
  min-width: 150px;
  max-width: 500px;
}
</style>
